import { tokenizeColors } from './tokenizeWelcomeMessageColors.ts';
import type { WelcomeMessagesQuery$data } from './__generated__/WelcomeMessagesQuery.graphql.ts';

export type WelcomeMessagesValue = {
	welcomeMessageEditUrl: string;
	welcomeMessageHtml: string;
	isWelcomeMessageCustomized: boolean;
	showWelcomeMessageEditHint: boolean;
	showEditButton: boolean;
	resourceKeys: string[];
	resourceContexts: string[];
};

export const welcomeMessagesDefaultValue: WelcomeMessagesValue = {
	welcomeMessageEditUrl: '',
	welcomeMessageHtml: '',
	isWelcomeMessageCustomized: false,
	showWelcomeMessageEditHint: false,
	showEditButton: false,
	resourceKeys: [''],
	resourceContexts: [''],
};

type Nullable<T> = {
	[P in keyof T]: T[P] | null;
};

function nonNull<T>(item: T | null | undefined): item is T {
	return item != null;
}

export const transformData = (
	data: WelcomeMessagesQuery$data | undefined,
): WelcomeMessagesValue => {
	if (!data) {
		return welcomeMessagesDefaultValue;
	}
	const {
		welcomeMessageEditUrl,
		welcomeMessageHtml,
		isWelcomeMessageCustomized,
		resourceKeys,
		resourceContexts,
		showWelcomeMessageEditHint,
		showEditButton,
	} = data.spaViewContext || {};

	const contextData: Nullable<Partial<WelcomeMessagesValue>> = {
		welcomeMessageEditUrl,
		welcomeMessageHtml,
		isWelcomeMessageCustomized,
		showWelcomeMessageEditHint,
		showEditButton,
		resourceKeys: resourceKeys?.filter(nonNull),
		resourceContexts: resourceContexts?.filter(nonNull),
	};

	// replace null values from query data with default values
	for (const [key, value] of Object.entries(contextData)) {
		if (value === null || value === undefined) {
			(contextData as any)[key] = (welcomeMessagesDefaultValue as any)[key];
		}
	}

	contextData.welcomeMessageHtml = tokenizeColors(contextData.welcomeMessageHtml ?? '');
	return contextData as WelcomeMessagesValue;
};
